var getBuiltIn = require('../internals/get-built-in');

module.exports = getBuiltIn('navigator', 'userAgent') || '';



//////////////////
// WEBPACK FOOTER
// ./~/vue-tel-input/~/core-js/internals/engine-user-agent.js
// module id = 1500
// module chunks = 1